import { EventSchedule } from '../tournament/tournament.models';

export enum GameTagsEnum {
  ARCADE = 'ARCADE',
  ACTION = 'ACTION',
  SHOOTER = 'SHOOTER',
  CARD_GAME = 'CARD GAME',
  STRATEGY = 'STRATEGY',
  SPORTS = 'SPORTS',
  BOARD_GAME = 'BOARD GAME',
}

export enum GameTypeEnum {
  ALL = 'ALL',
  CASUAL = 'CASUAL',
  LIVE = 'LIVE',
}

export interface Game {
  uuid: string;
  name: string;
  description: string;
  highScoreWins: boolean;
  key: string;
  gameType: string;
  eventSchedules?: EventSchedule[];
  blockedDevices: string[] | null;
  imageUrl?: string;
  imageCoverUrl?: string;
  metadata?: GameMetadata;
  fullSizeBannerImage?: string;
}

export interface GameMetadata {
  image?: string;
  format?: string;
  system?: string;
  browser?: string;
  experience?: string;
  description?: string;
  longDescription?: string;
}

export interface GameQueryParams {
  gameType?: GameTypeEnum;
  gameTags?: Array<GameTagsEnum> | string[];
  search?: string;
  clearCache?: boolean;
  pageIndex: number;
  pageSize: number;
}

export interface GameResponse {
  items: Game[];
  filters: GameFilters;
  total: number;
  pageIndex: number;
  pageSize: number;
  hasMore: boolean;
}

export interface GameFilters {
  gameTags: Array<GameTagsEnum>;
  gameType?: GameTypeEnum;
  gameId?: string;
  pageIndex?: number;
  pageSize?: number;
}
